$(() => {
  const $scanBtn = $('#scan');
  const $permissionCheck = $('#permissionCheck');
  
  // 初始化按钮状态
  function updateButtonState() {
    if ($permissionCheck.is(':checked')) {
      $scanBtn.removeClass('disabled');
    } else {
      $scanBtn.addClass('disabled');
    }
  }
  
  // 监听复选框变化
  $permissionCheck.on('change', function() {
    updateButtonState();
  });
  
  // 初始化时禁用按钮
  updateButtonState();
  
  $scanBtn.on('click', function (event) {
    // 检查是否选中了权限复选框
    if (!$permissionCheck.is(':checked')) {
      layer.open({
        content: '请先同意使用相机及相册权限',
        skin: 'msg',
        time: 2
      });
      return;
    }
    
    wx.scanQRCode({
      needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
      scanType: ["qrCode"], // 可以指定扫二维码还是一维码，默认二者都有
      success: function (res) {
        console.log(res);
        const result = res.resultStr; // 当needResult 为 1 时，扫码返回的结果
        const code = result.split('/').pop() || '';
        if (result.indexOf('51cjm.cn') !== -1) {
          $.toResultByCode(code, 1);
          console.log(1);
        } else if (result.indexOf('cjm.so') !== -1) {
          window.location.href = `http://wap.cjm.so/Operator/Common/AntiFakeQueryResult.aspx?code=${code}`
          console.log(2);
        } else {
          layer.open({
            content: '此码为假码，请联系厂家！',
            skin: 'msg',
            time: 2
          });
          console.log(3);
        }
      }
    });
  });
})